import { createApp } from 'vue'
import { createVfm } from 'vue-final-modal'
import App from '@/App.vue'
import '@/assets/app.css'
import router from '@/router'
import axios from 'axios'
import 'vue-final-modal/style.css'
import '@/assets/prayer.css'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import Lara from '@/lara';
import {createPinia} from "pinia";
import WebFont from 'webfontloader';
import { i18n } from '@/i18n';
import { vReveal } from '@/directives/reveal';

WebFont.load({
    google: {
        families: ['Roboto', 'Times New Roman', 'Arial']
    }
});

axios.defaults.baseURL = 'https://api.prayerapp.me'

const vfm = createVfm()
const pinia = createPinia()

createApp(App)
    .use(router)
    .use(vfm)
    .use(pinia)
    .use(i18n)
    .use(PrimeVue, {
        unstyled: true,
        pt: Lara
    })
    .directive('reveal', vReveal)
    .mount('#app')

